//noScroll
class FormEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const Item01 = document.querySelector('.step01');
    const Item02 = document.querySelector('.step02');
    const Item03 = document.querySelector('.step03');
    const Check = document.querySelector('.mw_wp_form');

    if(Check.classList.contains('.mw_wp_form_input')){
      Item01.classList.add('is-active')
    } else if(Check.classList.contains('.mw_wp_form_confirm')){
      Item01.classList.remove('is-active')
      Item02.classList.add('is-active')
    } else if(Check.classList.contains('.mw_wp_form_complete')){
      Item02.classList.remove('is-active')
      Item03.classList.add('is-active')
    } 
  }
}
